import { Fragment, useEffect, useState } from 'react';
import { getRewardEarnRule } from '@/service/vip';
import getLocal from '@/app/utils/getLocal';
import './index.scss';

import WaysToEarnPointsNew from 'lowcode/OldMember/WaysToEarnPointsNext';
import { getIsLogin } from '@/utils/cookie';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const [isClient, setIsClient] = useState(false);
    const [isLogin, setIsLogin] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [rewardEarnRule, setRewardEarnRule] = useState([]);
    const { locale } = getLocal();

    const queryRewardEarnRule = async () => {
        const res = await getRewardEarnRule(locale as string);
        if (res?.code === '0') {
            setRewardEarnRule(res.data || []);
        }
    };

    const refershData = () => {
        queryRewardEarnRule();
    };

    useEffect(() => {
        const _isLogin = getIsLogin();

        setIsLogin(_isLogin);
        setIsClient(true);

        _isLogin && queryRewardEarnRule();

        if (window.innerWidth <= 1024) {
            setIsMobile(true);
        }
    }, []);

    return <Fragment>{isClient && <WaysToEarnPointsNew isLogin={isLogin} data={data} rewardEarnRule={rewardEarnRule} refershData={refershData} />}</Fragment>;
}
